import m from "mithril"
import { state } from "../state/store.js"
import logo from "../assets/logo.svg"

export default {
  view: function () {
    var tagline = (state.settings && state.settings.footerTagline)
      || "Crafting digital experiences."
    var email = (state.settings && state.settings.email)
      || "mark@ismark.net"

    return m("footer.footer", { id: "contact" }, [
      m("div.footer-inner", [
        m("div.footer-brand", [
          m(m.route.Link, { href: "/", class: "footer-logo flex flex-row justify-center items-center gap-2" }, [
            m('img', { src: logo, alt: "Mark Logo", class: "w-8 h-8 inline-block mr-2" }),
            "I am Mark",
          ]),
          m("p.footer-tagline", tagline),
        ]),
        m("div.footer-contact", [
          m("h4", "Get in Touch"),
          m("a", { href: "mailto:" + email }, email),
        ]),
      ]),
      m("div.footer-bottom", [
        m("p", "\u00A9 2026 Mark. All rights reserved."),
      ]),
    ])
  },
}
